import { css } from 'styled-components';

const TitleWithInfo = css`
  .fee-title {
    border-bottom: 1px dashed #BBCBD8;
  }

  &:hover {
    cursor: pointer;

    .fee-title {
      border-bottom: 1px solid #C19D3F;
    }

    .question-mark {
      visibility: visible;
    }
  }
`;

const QuestionMark = css`
  padding-left: 4px;
  color: ${props => props.theme.primaryColor};
  font-weight: ${props => props.theme.fontWeightHeavy};
  font-size: 18px;
  visibility: hidden;
  line-height: 16px;
  letter-spacing: 0.1px;
  text-transform: uppercase;
`;

export {
  TitleWithInfo,
  QuestionMark,
};
